import "./_historique.scss";

import cx from "classnames";

import {formatDate} from "@/function/formatDate";
import {Status as StatusInterface} from "@/ts/interface/compte";
import {AdresseHistorique} from "@/ts/interface/compte";
import {EngagementArticle} from "@/ts/interface/detailOffre";

import Status from "./Status";

function HistoriqueMassificationContent({
  articles,
  status,

  adresse,
}: {
  status: StatusInterface | null;
  articles: EngagementArticle[];

  adresse: AdresseHistorique;
}): JSX.Element {
  const copyArticle = structuredClone(articles);
  const articlesComponent = copyArticle
    .filter(
      (article, index, self) =>
        index === self.findIndex(t => t.article_id === article.article_id),
    )
    .map(article => {
      return (
        <div key={article.article_id}>
          <h4>{article.designation}</h4>
          <p>
            <span>Quantité : </span>
            {`${article.quantite} unitées`}
          </p>
        </div>
      );
    });

  const dateLivraison: string[] = articles
    .filter(
      (article, index, self) =>
        index === self.findIndex(t => t.date === article.date),
    )
    .map(article => {
      return article.date || "";
    });

  const livraisonComponent = dateLivraison.map((date, index) => {
    const dateLivraison = formatDate(date);

    return (
      <p key={`${date} ${index}`}>
        {index + 1} : Au plus tard le
        <span>{` ${dateLivraison} `}</span>
      </p>
    );
  });

  const ProduitComponent = (
    <div className={cx("historique-engagement")}>
      <div className="historique-article">{articlesComponent}</div>
      <div className="historique-livraison">
        <div className="historique-livraison--adresse">
          <h5> Adresse : </h5>
          <p>
            <span>{` ${adresse?.address1 || ""} ${adresse?.address2 || ""} ${adresse?.address3 || ""}`}</span>
            <br />
            <span>{`${adresse?.postal_code || ""} ${adresse?.city || ""} `}</span>
          </p>
        </div>
        <div className="historique-livraison--date">
          <h5> Livraison{dateLivraison.length > 1 ? "s cadencées :" : " :"}</h5>
          {livraisonComponent}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {ProduitComponent}
      {status && <Status status={status} />}
    </>
  );
}

export default HistoriqueMassificationContent;
